var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_outline_lovely",
    "data-name": "vuesax/outline/lovely",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lovely"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.758,39.15a5.037,5.037,0,0,1-1.8-.293C12.262,36.225,0,26.82,0,12.915A12.887,12.887,0,0,1,12.847,0,12.685,12.685,0,0,1,21.78,3.622,12.724,12.724,0,0,1,30.712,0,12.887,12.887,0,0,1,43.56,12.915a22.463,22.463,0,0,1-.2,2.97,1.754,1.754,0,0,1-.832,1.26,1.691,1.691,0,0,1-1.507.09,6.836,6.836,0,0,0-8.01,2.115,1.915,1.915,0,0,1-1.35.675,1.663,1.663,0,0,1-1.35-.675A6.671,6.671,0,0,0,18.293,23.4c0,5.85,3.353,10.012,6.188,12.51a1.7,1.7,0,0,1-.248,2.722,2.491,2.491,0,0,1-.562.248A6.548,6.548,0,0,1,21.758,39.15ZM12.847,3.375a9.516,9.516,0,0,0-9.472,9.54c0,11.767,9.788,19.013,15.413,21.8a18.7,18.7,0,0,1-3.893-11.34,10.073,10.073,0,0,1,10.035-10.1,9.967,9.967,0,0,1,6.705,2.565,10.214,10.214,0,0,1,8.528-2.385v-.517A9.469,9.469,0,0,0,23.107,7.2a1.687,1.687,0,0,1-2.7,0A9.286,9.286,0,0,0,12.847,3.375Z",
    transform: "translate(2.813 5.287)",
    fill: "#d00c1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M16.717,30.15a4.471,4.471,0,0,1-1.485-.225,24.778,24.778,0,0,1-7.92-4.792C3.983,22.185,0,17.19,0,10.1A10.073,10.073,0,0,1,10.035,0a9.967,9.967,0,0,1,6.7,2.565A10.211,10.211,0,0,1,27.45.855a10.154,10.154,0,0,1,6.008,9.27c0,10.665-9.36,17.82-15.255,19.822A5.264,5.264,0,0,1,16.717,30.15ZM10.012,3.375A6.7,6.7,0,0,0,3.352,10.1c0,5.85,3.352,10.012,6.187,12.51a21.1,21.1,0,0,0,6.773,4.118,1.47,1.47,0,0,0,.765,0C20.452,25.583,30.06,20.07,30.06,10.1a6.733,6.733,0,0,0-3.982-6.165,6.853,6.853,0,0,0-8.01,2.115,1.915,1.915,0,0,1-1.35.675,1.663,1.663,0,0,1-1.35-.675A6.639,6.639,0,0,0,10.012,3.375Z",
    transform: "translate(17.753 18.563)",
    fill: "#d00c1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H54V54H0Z",
    fill: "none",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.52b3785260603565e92197b39997fa4d.svg";
export { ForwardRef as ReactComponent };